var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',[_c('v-col',[_c('h2',[_vm._v(" Create Report ")])])],1),_c('report')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }